<template>
  <p-select-button
    v-if="buttons"
    v-model="checked"
    :options
    :name
    :disabled
    :allow-empty
    :option-value
    :option-label
    :option-disabled
    :class="{ 't-radio-group-stacked': stacked }"
    :pt:pcToggleButton:root:class="optionClass"
    :pt:pcToggleButton:root:style="{
      'background-color': 'var(--p-primary-50)',
      'border-color': 'var(--p-primary-50)'
    }"
  >
    <template
      v-if="slots.option"
      #option="slotProps"
    >
      <slot
        name="option"
        :option="slotProps.option"
      ></slot>
    </template>
  </p-select-button>
  <p-radio-button-group
    v-else
    v-model="checked"
    :name
    :aria-describedby="null"
    :aria-labelledby="null"
    :aria-invalid="computedAriaInvalid"
    :aria-required="required ? 'true' : null"
    :class="{ 'd-block': stacked }"
    role="radiogroup"
  >
    <slot name="first"></slot>
    <t-radio
      v-for="(option, index) of options"
      :key="index"
      :name="name"
      :value="getValue(option)"
      :checked
      :disabled="disabled || optDisabled(option)"
      :class="optionClass"
      :label-class="labelClass"
      class="align-items-baseline"
    >
      <slot
        v-if="slots.option"
        name="option"
        :option
      ></slot>
      <span
        v-else-if="option.html"
        v-safe-html="option.html"
      ></span>
      <span v-else-if="option?.[optionLabel]">{{ option[optionLabel] }}</span>
      <span v-else>{{ option }}</span>
    </t-radio>
    <slot></slot>
  </p-radio-button-group>
</template>

<script setup>
import { ref, useSlots } from 'vue'

const slots = useSlots()

const checked = defineModel()

const props = defineProps({
  allowEmpty: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  buttons: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    required: true
  },
  labelClass: {
    type: String,
    default: ''
  },
  optionClass: {
    type: String,
    default: ''
  },
  optionDisabled: {
    type: [String, Function],
    default: 'disabled'
  },
  optionLabel: {
    type: [String, Function],
    default: 'text' // pv defaults to null, but we seem to use text
  },
  optionValue: {
    type: [String, Function],
    default: 'value' // pv defaults to null, but we seem to use value
  },
  options: {
    type: Array,
    default: () => []
  },
  stacked: {
    type: Boolean,
    default: false
  }
})

const getValue = (option) => {
  // @todo make this work with Functions
  if (typeof option === 'object' && option.hasOwnProperty(props.optionValue)) {
    return option[props.optionValue]
  }

  return option
}

const optDisabled = (option) => {
  // @todo make this work with Functions
  return option?.[props.optionDisabled]
}
</script>

<style lang="scss">
.p-selectbutton.t-radio-group-stacked {
  flex-direction: column;

  .p-togglebutton:first-child {
    border-start-end-radius: var(--p-selectbutton-border-radius);
    border-end-start-radius: 0;
  }

  .p-togglebutton:last-child {
    border-start-end-radius: 0;
    border-end-start-radius: var(--p-selectbutton-border-radius);
    border-end-end-radius: var(--p-selectbutton-border-radius);
  }
}
</style>
